import { motion } from "framer-motion";
import pp from "../dosyalar/aysun-hero.jpeg";
import AnasayfaBolumIDort from "../components/AnasayfaBolumDort";
import { Link } from "react-router-dom";
import TerapiYaklasimlari from "../components/TerapiYaklasimlari";
import { Mail, Phone } from "lucide-react";


const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export default function Home() {
  return (
    <div>
      <div className="relative isolate">

        {/* ÜST ARKA PLAN */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 -top-16 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-28"
        >
          <div
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36rem] -translate-x-1/2 rotate-30 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72rem]"
          />
        </div>

        {/* ANA ALAN */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          className="mx-auto max-w-2xl py-16 sm:py-20 lg:py-24"
        >
          {/* PROFİL */}
          <motion.div
            variants={item}
            className="mb-6 flex flex-col items-center"
          >
            <motion.img
              src={pp}
              alt="Aysun Şeremet Psikolog"
              className="w-[85vw] max-w-[340px] sm:max-w-[380px] md:max-w-[420px] aspect-[5/6] rounded-2xl object-cover object-center shadow-lg ring-4 ring-white mx-auto"
              initial={{ scale: 0.85, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.5 }}
            />

            <motion.h2 variants={item} className="mt-3 text-lg font-semibold text-gray-900">
              Aysun Şeremet
            </motion.h2>
            <motion.p variants={item} className="text-sm text-gray-500">Uzman Klinik Psikolog</motion.p>
          </motion.div>

          {/* ETİKET */}
          <motion.div
            variants={item}
            className="mb-5 flex justify-center"
          >
            <motion.div className="rounded-full px-3 py-1 text-sm text-gray-600 ring-1 ring-gray-900/10">
              Online & Yüz Yüze Danışmanlık
            </motion.div>
          </motion.div>

          {/* METİN */}
          <motion.div variants={item} className="text-center">
            <motion.h1
              className="text-2xl font-semibold tracking-tight text-gray-900 sm:text-4xl"
              variants={item}
            >
              Zorlayıcı yaşam dönemlerinde bilimsel ve güvenilir psikolojik destek…
            </motion.h1>

            <motion.p
              className="mt-5 text-base font-medium text-gray-600 sm:text-lg"
              variants={item}
            >
              Online ve yüz yüze psikolojik danışmanlık.
              
            </motion.p>
            <motion.div
  variants={item}
  className="mt-4 flex justify-center items-center gap-2 text-sm text-gray-600"
>
   <a
    href="tel:+905372153407"
    className="flex items-center gap-2 hover:text-pink-500 transition"
  >
    <Phone size={18} />
    +90 537 215 34 07
  </a>

  <p>I</p>

  {/* Mail */}
  <a
    href="mailto:info@aysunseremet.com"
    className="flex items-center gap-2 hover:text-pink-500 transition"
  >
    <Mail size={18} />
    info@aysunseremet.com
  </a>
</motion.div>
            {/* BUTONLAR */}
            <motion.div
              variants={item}
              className="mt-8 flex items-center justify-center gap-x-3"
            >
              <Link
                to="/randevu-al"
                className="rounded-md bg-pink-500 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition"
              >
                Randevu Al
              </Link>
              <a
                href="https://wa.me/905372153407"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-md bg-green-500 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-green-600 transition"
              >
                WhatsApp ile İletişime Geç
              </a>
            </motion.div>
          </motion.div>
        </motion.div>
<motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          variants={container}
        ><TerapiYaklasimlari />
        
       
          
        </motion.div>
        {/* ALT ARKA PLAN – Scroll ile animasyonlu */}
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          variants={container}
        ><AnasayfaBolumIDort />
        
       
          
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          variants={container}
        >
          
          
      
        
        </motion.div>

      </div>

    </div>
  );
}
